import { render } from "./PriceDisclaimer.vue?vue&type=template&id=b432db76"
const script = {}

import exportComponent from "C:\\Sites\\nvi-vue\\nvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__